import { $ } from '../vendors/jquery';

class Example
{
    constructor( element ) 
    {
        this.element = element;
        this.init();
    }

    init() 
    {
        console.log( 'MODULE EXAMPLE INIT' );
        $( 'body' ).addClass( 'module-example-loaded' );
    }
}

const example = {
    init() {
        const exampleElements = $( '[data-module="example"]' );

        if ( null !== exampleElements && exampleElements.length > 0 ) {
            exampleElements.each( ( index, element ) => {
                new Example( $( element ) );
            } );
        }
    }
};

export default example;
